const s = "_emphasis_ckq9c_1", p = "_wrapper_ckq9c_5", e = {
  emphasis: s,
  wrapper: p
};
export {
  e as default,
  s as emphasis,
  p as wrapper
};
